import { useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { KeyboardDoubleArrowUp, KeyboardDoubleArrowDown } from "@mui/icons-material";
import DebtWarehouseIcon from "../../../assets/img/debt-report.svg";
import DebtSalesIcon from "../../../assets/img/debt-sales-statistic.svg";
import useStatisticDebt from "src/hooks/debt/useStatisticDebt";
import useAuthGlobal from "src/context/useAuthGlobal";
import convertCurrency from "src/helper/convertCurrency";
import { formatCurrency } from "src/helper/convertNum";

const DebtWarehouseStatistic = () => {
  const [isHide, setIsHide] = useState(false);
  const { userMe } = useAuthGlobal();
  const { data: statistic } = useStatisticDebt({
    warehouse: userMe?.currentWarehouse?._id,
  });

  return (
    <Stack>
      <Button
        sx={{ display: "flex", maxWidth: "180px", ml: "auto", fontSize: "10px" }}
        onClick={() => setIsHide((prev) => !prev)}
        endIcon={!isHide ? <KeyboardDoubleArrowUp /> : <KeyboardDoubleArrowDown />}
      >
        {!isHide ? "Ẩn" : "Mở"} thống kê
      </Button>
      {!isHide && (
        <Stack
          direction="row"
          gap={2}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            width="50%"
            sx={{
              background: "var(--light-grey)",
              borderRadius: "6px",
              p: "17px 12px",
              boxSizing: "border-box",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>Tổng công nợ KHO:</Typography>
              <Typography sx={{ fontSize: "24px", fontWeight: "bold" }}>+{formatCurrency(statistic?.data?.warehouse)}</Typography>
              <Typography sx={{ fontSize: "10px", fontStyle: "italic" }}>{convertCurrency(statistic?.data?.warehouse)} đồng</Typography>
            </Box>
            <Box>
              <img
                src={DebtWarehouseIcon}
                alt="debt-report"
              />
            </Box>
          </Stack>
          <Stack
            width="50%"
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "var(--light-grey)",
              borderRadius: "6px",
              p: "17px 12px",
              boxSizing: "border-box",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>Tổng công nợ SALE:</Typography>
              <Typography sx={{ fontSize: "24px", fontWeight: "bold" }}>+{formatCurrency(statistic?.data?.customer)}</Typography>
              <Typography sx={{ fontSize: "10px", fontStyle: "italic" }}>{convertCurrency(statistic?.data?.customer)} đồng</Typography>
            </Box>
            <Box>
              <img
                src={DebtSalesIcon}
                alt="debt-sales-statistics"
              />
            </Box>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default DebtWarehouseStatistic;
